import { baseUrl } from "../api";

export const feedMessagesUrl = `${baseUrl}feed-messages/`;
